import { MOSCOW, NARO_FOMINSK, NOGINSK, KLIN, ST_PETERSBURG } from 'common/constants/region-codes';

export const FILTER_SYSTEMS_PATH =
  '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-filtracii-vody-dlya-zagorodnogo-doma-pod-klyuch/';

export const FILTER_DEVELOPMENT_ID = '1';

export const DEFAULT_DEVELOPMENT_PRICE = 3000;
export const DEVELOPMENT_PRICE = 5000;

export const FILTER_SYSTEMS_CONSULTATION_TYPE = 'WATER_FILTER';

export const FILTER_REGION_ID_LIST_WITH_PRICE_FOUR_THOUSAND = [
  NARO_FOMINSK,
  NOGINSK,
  MOSCOW,
  KLIN,
  ST_PETERSBURG,
];

export const FILTER_ELEMENT_BLOCK = 'landingSistemyFiltracii';

export const SERVICE_ID_FILTER = '2111';
